export class GatewayNetworkConfigurationValue
{
    constructor(json: object = null)
    {
        if (json)
        {
            // Map the json object to 'this' objects properties.
            Object.assign(this, json);

            // Handle any custom mappings here.
        }
    }

    public EnableDHCP: boolean;
    public IPAddress: string;
    public SubnetAddress: string;
    public DNS1: string;
    public DNS2: string;
    public Gateway: string;
    public MacAddress: string;
}
